<!--
   Created by qing on 2020/2/18 4:28 下午
   Des:
-->
<template>
  <div v-if="filterWay">
    <SelectValue
      :disabled="disabled"
      :fields="fields"
      :isMultiple="isMultiple"
      :filterValue="current"
      :filter="filter"
      :formId="formId"
      @change="filterChange">
    </SelectValue>
  </div>

  <van-checkbox-group
    v-else
    @change="filterChange"
    v-model="current">
    <van-checkbox
      :disabled="disabled"
      v-for="(opt, idx) in field.options"
      icon-size="16"
      shape="square"
      :key="opt.id"
      :name="opt.id">
          <span :style="{backgroundColor: current.showColor ? opt.color : '#fff', color: current.showColor ? '#fff' : '#000'}">
            {{ opt.optionName }}
          </span>
    </van-checkbox>
  </van-checkbox-group>
</template>

<script>
  import current from "./mixin"
  export default {
    mixins: [current],
    data() {
      return {};
    },
    computed: {
    }
  };
</script>

<style lang="less">

</style>
